// ============================================================
// Instance partagée du client API Siverix
// ============================================================

import { SiverixApi } from '@siverix/api-client';
import { API_BASE } from './apiBase';

let accessToken: string | null = null;
const tokenListeners = new Set<(t: string | null) => void>();

export const api = new SiverixApi({
  baseUrl: API_BASE,
  getAccessToken: () => accessToken,
  setAccessToken: (t) => {
    accessToken = t;
    tokenListeners.forEach((cb) => cb(t));
  },
  onUnauthorized: () => {
    accessToken = null;
    tokenListeners.forEach((cb) => cb(null));
  },
});

export function onTokenChange(cb: (t: string | null) => void): () => void {
  tokenListeners.add(cb);
  return () => tokenListeners.delete(cb);
}

export function getAccessToken(): string | null {
  return accessToken;
}
